#import "../../../../email-marketing/graphql/fragments/email-membership-stats-fragment.graphql"
#import "../../../../email-marketing/graphql/fragments/sms-membership-stats-fragment.graphql"

fragment AudienceFragment on Audience {
    id
    name
    type
    isWebFX
    isSyncing
    htmlUrl
    htmlUrlPath
    htmlUrlPathForList
    fromSavedFilter {
        id
        name
        htmlUrlPath
        filterString
        entityType
        count {
            value
            suffix
            prefix
            formatted
        }
    }
    membershipStats {
        ...EmailMembershipStatsFragment
    }
    smsMembershipStats {
        ...SmsMembershipStatsFragment
    }
}
